import { SOCKET_GAME_PATH, SOCKET_CHAT_PATH } from "@client/lib/globals";
import { io, Socket, type ManagerOptions } from "socket.io-client";
import type { ToServerIO, ToClientIO } from "@client/types";
import { onBeforeUnmount } from "vue";

const originalOn = Socket.prototype.on;
Socket.prototype.on = function (event, handler) {
	onBeforeUnmount(() => this.off(event, handler));
	if (!this.hasListeners(event)) originalOn.call(this, event, handler);
	return undefined as any;
};

type Event = { [event: string]: any };

function initSocket<C extends Event, S extends Event>(
	path: string,
	options: Partial<ManagerOptions> = {
		autoConnect: false,
		withCredentials: true,
	},
) {
	return io(path, options) as Socket<C, S>;
}

export const $socket = {
	game: initSocket<ToClientIO.Game.Events, ToServerIO.Game.Events>(SOCKET_GAME_PATH),
	social: initSocket<ToClientIO.Social.Events, ToServerIO.Social.Events>(SOCKET_CHAT_PATH),
};
